module.exports = __webpack_public_path__ + "59e7d93739c9caf0326302a4759a5e9c.svg";